import { createRouter } from "@tanstack/react-router";
import { routeTree } from "@/routeTree.gen";
import { ErrorHandler } from "@/shared/ui/error-handling/ui/error-handler";
import { ErrorPage } from "@/shared/ui/error-handling/ui/error-page";
import * as React from "react";

export const router = createRouter({
  routeTree,
  context: {},
  defaultViewTransition: true,
  defaultErrorComponent: ({ error }) => {
    return <ErrorHandler error={error} />;
  },
  defaultNotFoundComponent: () => <ErrorPage statusCode={404} />,
  defaultPreloadStaleTime: Infinity,
});
